import React from "react";
import NameInfo from "./NameInfo";
import Answer from "./Answer";

export default function NewAnswerCard({question,answer}) {
    return (
        <>
        <NameInfo data={answer} question={question} />
        <Answer data={answer} question={question} />
        </>
    )
}